module.exports = __webpack_public_path__ + "static/bg02-09b4f8b76340229fd16ef5745881fbb0.jpg";